import React, { useRef, useState } from 'react'
import styled from 'styled-components'

import { device } from '@/common/constants/device'
import useOutsideClick from '@/hooks/useOutsideClick'

const Dropdown = styled.div`
  position: relative;

  @media ${device.toLaptopL} {
    display: ${(props) => (props.hideToLaptopL ? 'none' : 'block')};
  }
`
const DropdownTrigger = styled.button`
  cursor: pointer;

  background-color: transparent;

  width: 100%;
`

const DropdownTriggerDefault = styled.div`
  position: relative;

  color: ${(props) => (props.color ? `var(--${props.color})` : '#6E7278')};

  font-weight: 400;
  font-size: 18px;
  line-height: 140%;

  width: 100%;

  text-align: left;

  @media ${device.laptop} {
    padding-right: 20px;
  }

  ::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: ${(props) =>
      props.active
        ? 'rotate(180deg) translateY(50%)'
        : 'rotate(0) translateY(-50%)'};
    mask-image: url('/_next_static/icons/dropdown-icon.svg');
    mask-size: cover;
    mask-position: center;
    mask-repeat: no-repeat;
    background-color: #333333;
    width: 16px;
    height: 16px;
  }
`
const DropdownContent = styled.div`
  padding-top: 24px;
  border-top: 1px solid #d4dced;
  background-color: var(--white);

  @media ${device.laptopL} {
    border-top: none;
    padding: 16px;
    box-shadow: 0px 0px 0px 0px rgba(27, 27, 68, 0.08),
      -1px 6px 13px 0px rgba(27, 27, 68, 0.08),
      -2px 24px 24px 0px rgba(27, 27, 68, 0.07),
      -5px 54px 32px 0px rgba(27, 27, 68, 0.04),
      -9px 96px 38px 0px rgba(27, 27, 68, 0.01),
      -13px 149px 42px 0px rgba(27, 27, 68, 0);
    border-radius: 16px;
    border-radius: 16px;

    position: absolute;

    right: 0;

    z-index: 2;

    margin-top: ${(props) =>
      props.marginTop ? `${props.marginTop}px` : '40px'} !important;

    min-width: ${(props) => (props.width ? `${props.width}px` : '360px')};
  }
`

const HeaderDropdown = ({
  triggerColor,
  triggerText,
  children,
  customTrigger,
  isDropdown,
  triggerClickCallback,
  contentMargin,
  contentWidth,
  isTriggerCallback = true,
  ...props
}) => {
  const [isContentVisible, setIsContentVisible] = useState(false)
  const wrapperRef = useRef(null)

  useOutsideClick(() => {
    if (isDropdown) {
      setIsContentVisible(false)

      if (triggerClickCallback && isTriggerCallback) {
        triggerClickCallback(false)
      }
    }
  }, wrapperRef)

  const onClick = () => {
    setIsContentVisible(!isContentVisible)

    if (triggerClickCallback) {
      triggerClickCallback(!isContentVisible)
    }
  }

  return (
    <Dropdown ref={wrapperRef} {...props}>
      <DropdownTrigger onClick={onClick}>
        {customTrigger || (
          <>
            <DropdownTriggerDefault
              color={triggerColor}
              active={isContentVisible}
            >
              {triggerText}
            </DropdownTriggerDefault>
          </>
        )}
      </DropdownTrigger>
      {isContentVisible ? (
        <DropdownContent marginTop={contentMargin} width={contentWidth}>
          {children}
        </DropdownContent>
      ) : null}
    </Dropdown>
  )
}

export default HeaderDropdown
